import { enUS, pt } from "date-fns/locale";

export const getDateFnsLocale = (language) => {
  if (typeof language === "string" && language.toLowerCase().startsWith("pt")) {
    return pt;
  }
  return enUS;
};
